module.exports = __webpack_public_path__ + "img/check_blue.447f89df.png";